import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { unLikeComment } from '../utils/backend-api/comments';
import { CURRENT_USER_KEY } from '../utils/backend-api/currentUser';

export default function useCommentUnLike(onSuccess: () => void) {
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError } = useMutation((id: number) => unLikeComment(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(CURRENT_USER_KEY);
      onSuccess();
    },
    onError: () => {
      toast.error('Comment unlike failed, please try again');
    },
  });

  return { mutate, isLoading, isError };
}
